/**
 *
 * DialogDescription
 *
 */

import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { StyledDialogDescription } from './DialogDescription.styles';

const DialogDescription = ({ children, ...props }) => (
  <StyledDialogDescription {...props}>{children}</StyledDialogDescription>
);

DialogDescription.propTypes = {
  children: PropTypes.node,
};

export default memo(DialogDescription);
